<template>
<div>

  <v-overlay v-if="loading" :value="loading">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-overlay>
  <div v-else>
    <v-row>
      <v-col cols="12" sm="2">
        <MyButtons />
      </v-col>
      <v-col cols="12" sm="3">
        <p class="mytitle primary--text">لیست {{formTitle}}</p>
      </v-col>
    </v-row>
    <MyListTable :headers="headers" :data="data" />

  </div>
</div>
</template>

<script>
import myAxios from '../../../functions/myAxios'
import MyListTable from '../../list/Table.vue'
import MyButtons from '../Buttons.vue'
export default {
  name: 'reportBalance',
  data: () => ({
    loading : true,
    data: [],
  }),
  created() {
    this.type = this.$router.currentRoute.path.split("/")[2]
    // console.log(type);
    this.route = this.$store.getters.pageInfo.route
    if (this.type === 'init') {
      this.formTitle = this.$store.getters.pageInfo.formTitle + ' اول دوره'
      this.headers = this.$store.getters.pageInfo.initHeaders
    } else { // current
      this.formTitle = this.$store.getters.pageInfo.formTitle + ' فعلی'
      this.headers = this.$store.getters.pageInfo.currentHeaders
    }
  },
  async mounted() {
    try {
      let res = await myAxios({
        method: 'GET',
        url: `/api/reports/balances/${this.type}`,
      });
      // console.log(res.data);
      if (res && res.data) {
        this.data = res.data
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false
    }
  },
  components: {
    MyListTable,
    MyButtons,
  }
}
</script>

<style lang="css" scoped>
</style>
